module.exports = __webpack_public_path__ + "img/img_my_bg_0.dac3b93d.jpg";